import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, isNavigating: false };
  }

  static getDerivedStateFromError(error) {
    // During navigation, suppress errors briefly
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Suppress errors during initial mount and navigation
    if (this.props.suppressErrors) {
      console.log('Error suppressed during navigation:', error);
      // Auto-recover after a brief moment
      setTimeout(() => {
        this.setState({ hasError: false });
      }, 100);
    } else {
      console.error('ErrorBoundary caught an error:', error, errorInfo);
    }
  }

  componentDidUpdate(prevProps) {
    // Reset error state when location changes
    if (prevProps.location !== this.props.location) {
      this.setState({ hasError: false });
    }
  }

  render() {
    // During navigation or if suppressErrors is true, don't show error UI
    if (this.state.hasError && !this.props.suppressErrors) {
      return (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          background: '#FDFBF7',
          padding: '2rem'
        }}>
          <div style={{
            textAlign: 'center',
            maxWidth: '600px'
          }}>
            <h1 style={{
              fontFamily: 'Noto Serif Display, serif',
              fontSize: '2.5rem',
              color: '#111',
              marginBottom: '1rem'
            }}>
              Something went wrong
            </h1>
            <p style={{
              color: '#4A4A4A',
              marginBottom: '2rem'
            }}>
              We're sorry for the inconvenience. Please refresh the page to continue.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: 'linear-gradient(135deg, #D4AF37 0%, #C29A4B 100%)',
                color: '#111',
                padding: '1rem 2rem',
                borderRadius: '12px',
                border: 'none',
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
